'use client';

import { HeaderDropdowns } from '@/components/NewHeader/HeaderDropdowns';
import { LoginButton } from '@/components/NewHeader/LoginButton';
import { SearchButton } from '@/components/NewHeader/SearchButton';
import { SideMenuTrigger } from '@/components/NewHeader/SideMenuTrigger';
import { useHeaderScroll } from '@/components/NewHeader/useHeaderScroll';
import ShortListModalContent from '@/components/ShortListModalContent';
import { useTranslation } from '@/contexts/dictionaryContext';
import { useHomePageUrl } from '@/hooks/useLocale';
import useUserContext from '@/hooks/useUserContext';
import { cn } from '@/lib/utils';
import Image from 'next/image';
import Link from 'next/link';
import { MdOutlineEmail, MdOutlinePhone } from 'react-icons/md';
import logoBlue from '../../../public/logo-desktop.svg';
import logoWhite from '../../../public/white-desktop-logo.svg';

export function TopHeader() {
  const { isActive } = useHeaderScroll();
  const { header } = useTranslation();
  const { isLogged } = useUserContext();
  const url = useHomePageUrl();

  return (
    <div className="lg:container 3xl:max-w-screen-2xl px-4 mx-auto flex justify-between items-center py-4 lg:py-8 relative h-[72px]">
      <div className="lg:hidden flex items-center">
        <SideMenuTrigger />
      </div>
      <div className="hidden lg:flex gap-4">
        <div className="flex items-center gap-3">
          <MdOutlinePhone
            width={16}
            height={16}
            className={cn(isActive ? 'fill-current/90' : 'fill-white')}
          />
          <a
            href={`tel:${header.nav.phone.replace(/\D/g, '')}`}
            className="text-sm whitespace-nowrap"
            title="Contact Us">
            {header.nav.phone}
          </a>
        </div>

        <Divider />

        <div className="flex items-center gap-3">
          <MdOutlineEmail
            width={16}
            height={16}
            className={cn(isActive ? 'fill-current/90' : 'fill-white')}
          />
          <a
            href="mailto:info@villatravellers.com"
            className="text-sm whitespace-nowrap"
            title="Contact Us">
            info@villatravellers.com
          </a>
        </div>
      </div>

      <div className="lg:absolute lg:left-1/2 lg:transform lg:-translate-x-1/2 px-3">
        <Link href={url}>
          <Image
            priority={true}
            src={isActive ? logoBlue : logoWhite}
            className="h-10 w-auto"
            alt="Logo Villatravellers"
          />
        </Link>
      </div>

      <div className="flex items-center gap-2 lg:gap-6">
        <ShortListModalContent />

        <Divider className="hidden lg:flex" />

        <div className="relative hidden lg:flex gap-2">
          <HeaderDropdowns />
        </div>

        <div className="hidden lg:flex">
          <SearchButton />
        </div>

        <div className={cn(isLogged ? 'flex' : 'hidden', 'lg:flex')}>
          <LoginButton />
        </div>
      </div>
    </div>
  );
}

function Divider({ className }: { className?: string }) {
  const { isActive } = useHeaderScroll();

  return (
    <div
      className={cn(
        className,
        'h-6 w-px bg-black/50 lg:bg-white/50 opacity-80 my-auto',
        isActive && 'lg:bg-black/50',
      )}
    />
  );
}
